'use strict';

function getConsoleFunction(funcName) {
    if(window.console) {
        return (window.console[funcName]) ? window.console[funcName] : function() {};
    }
}

function dir(object) {
    getConsoleFunction('dir')(object);
}

function log(...messages) {
    getConsoleFunction('log')(...messages);
}

export default {
    dir: dir,
    log: log
};


// WEBPACK FOOTER //
// ./src/react/ConsoleShim.js